export const initialDialog = {
  isOpen: false,
  data: null,
}
